const reactTInit = () => {
  if (typeof Drupal !== 'undefined') {
    /*global Drupal:true*/
    Drupal.t('Site name');
    Drupal.t('Type');
    Drupal.t('Topic');
    Drupal.t('Tags');
    Drupal.t('Keywords');
    Drupal.t('Document type');
    Drupal.t('Publication category');
    Drupal.t('Country');
    Drupal.t('Region');
    Drupal.t('Date');
    Drupal.t('Showing @count results for');
    Drupal.t('Sorry, your search yielded no results.');
    Drupal.t('Sort by');
    Drupal.t('Relevance');
    Drupal.t('Reset all filters');
    Drupal.t('Filters');
    Drupal.t('Start Date');
    Drupal.t('End Date');
    Drupal.t('Last 3 months');
    Drupal.t('Last 1 year');
    Drupal.t('Last 3 years');
    Drupal.t('There are no results to filter.');
    Drupal.t('Search tips');
    Drupal.t('Show all');
    Drupal.t('Show all topics');
    Drupal.t('Show all tags');
    Drupal.t('Show all keywords');
    Drupal.t('Clear selection');
    Drupal.t('Global site');
    Drupal.t('Africa site');
    Drupal.t('Asia site');
    Drupal.t('Australia site');
    Drupal.t('Ireland site');
    Drupal.t('India site');
    Drupal.t('Malaysia site');
    Drupal.t('US site');
    Drupal.t('Spain site');
    Drupal.t('Mexico site');
    Drupal.t('Europe site');
    Drupal.t('France site');
    Drupal.t('Korean site');
    Drupal.t('UK site');
    Drupal.t('Date');
    Drupal.t('Audience');
    Drupal.t('The search feature is currently unavailable due to technical maintenance. Please try again later. Thank you for your understanding.');
    Drupal.t('Loading fallback results...');
  }
};

const reactT = (string, options = []) => {
  if (typeof Drupal !== 'undefined') {
    /*global Drupal:true*/
    return Drupal.t(string, options);
  }
  return string;
};

export default reactT;
